import React from "react";
import { Col } from "react-bootstrap";
import { useFormikContext } from "formik";

const BFileField = ({ error, md, label, onChange, name, ...props }) => {
    const { setFieldValue } = useFormikContext();

    const handleChange = (event) => {
        setFieldValue(name, event.currentTarget.files[0]);
    };

    return (
        <React.Fragment>
            <Col md={md}>
                <div className="form-group">
                    <label htmlFor="file">{label}</label>
                    {/* <input
                        // id={name}
                        name={name}
                        type="file"
                        onChange={handleChange}
                        className="form-control"
                        // accept="*"
                        accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.csv"
                        {...props}
                    /> */}
                    <input
                        name={name}
                        type="file"
                        onChange={handleChange}
                        className="form-control"
                        accept=".xls,.xlsx,.csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        {...props}
                    />

                    {!!error ? <small className="text-danger">{error}</small> : null}
                </div>
            </Col>
        </React.Fragment>
    );
};

BFileField.defaultProps = {
    md: 12,
    label: "Choose File",
    error: ""
};

export default BFileField;
